/**
 * MS Cart Back Sync v9
 * Works with customize-back-button.liquid v7: each "Name and Number Back" is a
 * Shopify NESTED cart line under its shirt. Shopify removes the back when the
 * shirt is removed. This script only:
 *   1. Keeps the back's quantity equal to its shirt's quantity
 *   2. Locks the back's own quantity controls
 *   3. Shows the uploaded back preview as the thumbnail / inline image
 *   4. Removes product links on back lines
 *   5. Re-checks quantities before checkout
 * SCOPE: /cart page only.
 */
(function(){
  'use strict';
  if (window.location.pathname !== '/cart') return;

  var PREVIEW_PROP = 'Back Preview';
  var syncing = false;

  function getCart(){
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); });
  }
  function changeLine(key, qty){
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function(r){ return r.json(); });
  }
  function parentKey(item){ return item.parent_relationship && item.parent_relationship.parent_key; }

  function mismatches(cart){
    var byKey = {}, out = [];
    cart.items.forEach(function(i){ byKey[i.key] = i; });
    cart.items.forEach(function(i){
      var pk = parentKey(i);
      if (!pk || !byKey[pk]) return;
      if (i.quantity !== byKey[pk].quantity) out.push([i.key, byKey[pk].quantity]);
    });
    return out;
  }
  function fixQuantities(cart){
    var todo = mismatches(cart);
    if (!todo.length) return Promise.resolve(false);
    return todo.reduce(function(p, t){ return p.then(function(){ return changeLine(t[0], t[1]); }); }, Promise.resolve())
      .then(function(){ return true; });
  }

  function decorate(cart){
    cart.items.forEach(function(item, idx){
      if (!parentKey(item)) return;
      var row = document.getElementById('CartItem-' + (idx + 1));
      if (!row || row.getAttribute('data-msb-done') === item.key + ':' + item.quantity) return;
      var preview = item.properties && item.properties[PREVIEW_PROP];
      if (preview) {
        var img = row.querySelector('.cart-item__image');
        if (img) { img.src = preview; img.removeAttribute('srcset'); img.removeAttribute('height'); img.style.height = 'auto'; img.alt = 'Back preview'; }
        var links = row.querySelectorAll('.product-option a[href*="/uploads/"]');
        for (var i = 0; i < links.length; i++) {
          links[i].innerHTML = '<img src="' + preview + '" alt="Back preview" style="display:block;width:90px;height:auto;border:1px solid #e5e7eb;border-radius:6px;margin-top:4px">';
        }
      }
      var a = row.querySelectorAll('a.cart-item__name, a.cart-item__link');
      for (var j = 0; j < a.length; j++) { a[j].removeAttribute('href'); a[j].style.pointerEvents = 'none'; a[j].style.textDecoration = 'none'; }
      var q = row.querySelector('quantity-input');
      if (q) {
        var ctrls = q.querySelectorAll('input, button');
        for (var k = 0; k < ctrls.length; k++) ctrls[k].disabled = true;
        q.style.opacity = '.55';
        q.title = 'Matches the shirt above';
      }
      row.setAttribute('data-msb-done', item.key + ':' + item.quantity);
    });
  }

  function run(){
    if (syncing) return Promise.resolve();
    syncing = true;
    return getCart()
      .then(function(cart){
        return fixQuantities(cart).then(function(changed){
          if (changed) { window.location.reload(); return; }
          decorate(cart);
        });
      })
      .catch(function(e){ console.error('[MS Back Sync]', e); })
      .then(function(){ syncing = false; });
  }

  function hookPubSub(){
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function(){ setTimeout(run, 150); });
      return true;
    }
    return false;
  }

  var moTimer = null;
  var mo = new MutationObserver(function(){
    clearTimeout(moTimer);
    moTimer = setTimeout(function(){ getCart().then(decorate).catch(function(){}); }, 120);
  });

  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!btn || btn.getAttribute('data-msb-ok') === '1') return;
    e.preventDefault();
    e.stopPropagation();
    getCart().then(fixQuantities)
      .then(function(){ btn.setAttribute('data-msb-ok', '1'); btn.click(); })
      .catch(function(){ btn.setAttribute('data-msb-ok', '1'); btn.click(); });
  }, true);

  function init(){
    if (!hookPubSub()) setTimeout(hookPubSub, 500);
    var root = document.getElementById('main-cart-items') || document.getElementById('MainContent') || document.body;
    mo.observe(root, { childList: true, subtree: true });
    run();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
